module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'zamrmqqy',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
